<template>
  <div>
    <div class="wrap">
      <div class="activities">
        <div ref="header" class="tabs-wrap">
          <ul class="tabs">
            <li v-for="(item, index) in tabs" :key="item" class="tabs-item pointer" :class="{ active: isActive === index }" @click="getTabs(index)">
              <span>{{ item }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="result">
      <ul>
        <li v-for="item in dataList" :key="item.title">
          <ActivitiesItem :id="item.id">
            <template slot="status">
              <div v-if="item.applyStatus" class="declare" />
            </template>
            <template slot="title">
              {{ item.activityName }}
            </template>
            <template slot="content">
              <div class="item">主办单位：{{ item.organizer }}</div>
              <div class="item">活动时间：{{ item.activityTime }}</div>
              <div class="item">活动状态：{{ item.statusDsr }}</div>
              <div class="item">活动地点：{{ item.activityPlace }}</div>
            </template>
          </ActivitiesItem>
        </li>
      </ul>
      <div class="clear" />
    </div>

    <el-pagination
      layout="prev, pager, next"
      :current-page="pageNo"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      :background="true"
      :total="total"
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
    />
  </div>
</template>

<script>
import ActivitiesItem from '@/components/ActivitiesItem'
import grid from '@/mixins/grid'
export default {
  name: 'TalentActivities',
  components: { ActivitiesItem },
  mixins: [grid],
  data() {
    return {
      isActive: 0,
      tabs: ['全部活动', '重点品牌活动', '研修培训活动', '联谊交流活动', '金融对接活动', '产智对接活动', '赛事选才活动', '暖心服务活动', '其他活动'],
      module: '/zzmh/api/activity/',
      dataForm: {
        infoStatus: 1,
        activityType: '',
      },
      dataList: [],
      gridOptions: {},
      defOrders: [
        {
          k: 'seq',
          t: 'asc',
        },
      ],
      dataMode: {},
      allList: [],
      total: '',
    }
  },
  computed: {},
  methods: {
    getTabs(index) {
      this.pageNo = 1
      this.pageSize = 10
      this.isActive = index
      if (this.isActive > 0) {
        this.dataForm.activityType = this.tabs[this.isActive]
      } else {
        this.dataForm.activityType = ''
      }
      this.listData()
      // if (this.isActive > 0) {
      //   let qry = this.$query.new()
      //   this.$query.toR(qry, 'activityType', this.tabs[this.isActive])
      //   this.$query.toR(qry, 'infoStatus', 1)
      //   this.$http({ method: 'GET', url: '/zzmh/api/activity/page?query=' + this.$query.toEncode(qry) }).then((res) => {
      //     console.log(res)
      //     if (res.code === 0) {
      //       this.dataList = res.data.list
      //       this.total = res.page.total
      //     }
      //   })
      // } else {
      //   this.listData()
      // }
    },
  },
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
